import PropTypes from 'prop-types';
import { useLocation, matchPath, Link } from 'react-router-dom';

// react-bootstrap
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

// third-party
import { FormattedMessage } from 'react-intl';

// project-imports
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';

export default function NavItem({ item }) {
  const { pathname } = useLocation();
  const { menuOrientation, onChangeMenuOrientation } = useConfig();
  const itemPath = item?.link || item?.url;

  let itemTarget = '_self';
  if (item.target) {
    itemTarget = '_blank';
  }
  // Add/edit/view pages sit under their module's path (/users/add, /restaurant/view/3);
  // event pages belong to Tickets.
  const ALSO_UNDER = { '/ticket': ['/event'] };
  const isSelected = itemPath
    ? [itemPath, ...(ALSO_UNDER[itemPath] || [])].some((p) => !!matchPath({ path: p, end: false }, pathname))
    : false;

  // On desktop the drawer flag means the sidebar is shrunk to its icon rail;
  // only then does an item need a tooltip to say what it is.
  const { menuMaster } = useGetMenuMaster();
  const isRail = !!menuMaster?.isDashboardDrawerOpened && window.innerWidth > 1024;

  const link = (
    <Link
      className="pc-link"
      to={item?.url || '#'}
      target={itemTarget}
      onClick={() => {
        // Closing the drawer is for the mobile slide-in; on desktop it would
        // pop the shrunk rail back open on every click.
        if (window.innerWidth <= 1024) handlerDrawerOpen(false);
        if (item?.layout === item?.title) {
          onChangeMenuOrientation(item?.layout);
        }
      }}
    >
      {item?.icon && (
        <span className="pc-micon">
          <i className={typeof item.icon === 'string' ? item.icon : item.icon?.props.className} />
        </span>
      )}
      <span className="pc-mtext">
        <FormattedMessage id={item.title} />
      </span>
    </Link>
  );

  return (
    <li className={`pc-item ${isSelected ? 'active' : ''} `}>
      {menuOrientation !== MenuOrientation.TAB ? (
        isRail ? (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={`tooltip-rail-${item.id}`}>
                <FormattedMessage id={item.title} />
              </Tooltip>
            }
          >
            {link}
          </OverlayTrigger>
        ) : (
          link
        )
      ) : (
        <>
          {menuOrientation !== MenuOrientation.TAB && (
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id={`tooltip-${item.title}`}>
                  <FormattedMessage id={item.title} />
                </Tooltip>
              }
            >
              <Link
                className="pc-link"
                to={item?.url || ''}
                target={itemTarget}
                onClick={() => {
                  if (item?.layout === item?.title) {
                    onChangeMenuOrientation(item?.layout);
                  }
                }}
              >
                {item?.icon && (
                  <span className="pc-micon">
                    <i className={typeof item.icon === 'string' ? item.icon : item.icon?.props.className} />
                  </span>
                )}
              </Link>
            </OverlayTrigger>
          )}
        </>
      )}
    </li>
  );
}

NavItem.propTypes = { item: PropTypes.any };
